// Nobre — navegação principal: abrir/fechar submenus por toque, clique e teclado (padrão disclosure).
// O hover em rato é CSS puro. Listeners delegados no document: um só registo, sobrevive a re-renders.
const ITEM = '.nobre-nav__item--has-menu, .nobre-nav__subitem--has-menu';
const OPEN = 'is-open';

function setOpen(item, open) {
  item.classList.toggle(OPEN, open);
  item.querySelector(':scope > .nobre-nav__toggle')?.setAttribute('aria-expanded', String(open));
  if (open) keepInViewport(item);
}

// Fecha tudo, exceto o item indicado e os seus ancestrais.
function closeAll(keep) {
  for (const item of document.querySelectorAll(`.nobre-nav .${OPEN}`)) {
    if (!keep || !item.contains(keep)) setOpen(item, false);
  }
}

// Painel/flyout que sairia à direita do ecrã abre para o lado oposto.
function keepInViewport(item) {
  const box = item.querySelector(':scope > .nobre-nav__panel, :scope > .nobre-nav__flyout');
  if (!box) return;
  box.classList.remove('is-flipped');
  if (box.getBoundingClientRect().right > document.documentElement.clientWidth) box.classList.add('is-flipped');
}

document.addEventListener('click', (event) => {
  const target = event.target;
  const toggle = target.closest('.nobre-nav__toggle');
  // Link sem destino real (href="#") em item com filhos faz de botão em vez de saltar para o topo.
  const link = target.closest('.nobre-nav a[href="#"]');
  const item = (toggle ?? link)?.closest(ITEM);

  if (!item || (link && link.parentElement !== item)) {
    if (!target.closest('.nobre-nav')) closeAll();
    return;
  }
  if (link) event.preventDefault();
  const open = !item.classList.contains(OPEN);
  closeAll(item);
  setOpen(item, open);
});

document.addEventListener('pointerover', (event) => {
  const item = event.target.closest?.('.nobre-nav__subitem--has-menu, .nobre-nav__item--has-menu');
  if (item) keepInViewport(item);
});

document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  // Foco volta ao botão do item de topo (os de níveis inferiores ficam dentro de painéis que fecham).
  const top = document.activeElement?.closest(`.nobre-nav__list > .${OPEN}`);
  closeAll();
  top?.querySelector(':scope > .nobre-nav__toggle')?.focus();
});
